// @flow

import type { Node } from "react";
import React from "react";

import { ContinueLink } from "@/components";
import type { Variant } from "@/components/ContinueLink/ContinueLink";
import JsonPageRenderer from "@/utils/JsonPageRenderer/JsonPageRenderer";
import type { ItemRenderer, PageItem } from "@/utils/JsonPageRenderer/types";

interface ContinueLinkPageItem extends PageItem {
    props: {
        [string]: any,
        variant: Variant,
        link: Link,
        target: string,
    };
}

/**
 * Converts a ContinueLinkPageItem into a ContinueLink node.
 */
class ContinueLinkRenderer implements ItemRenderer<ContinueLinkPageItem> {
    render(context: JsonPageRenderer, item: ContinueLinkPageItem): Node {
        return (
            <ContinueLink
                key={item.id}
                variant={item.props.variant}
                to={item.props.link.path}
                target={item.props.link.target}
            >
                {item.props.link.text}
            </ContinueLink>
        );
    }

    match(item: PageItem): ContinueLinkPageItem | null {
        if (item.type === "continue-link") {
            return item;
        }
        return null;
    }
}

export default ContinueLinkRenderer;
